import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { unique } from '@cli-utils/shared.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'

export function assertNoIntegrationConflicts(
  integrationIds: BetterstartIntegrationId[],
  installedIntegrationIds: BetterstartIntegrationId[]
): void {
  const combined = unique([...installedIntegrationIds, ...integrationIds])

  for (const integrationId of combined) {
    const definition = getIntegrationDefinition(integrationId)
    const conflict = combined.find(
      (candidate) =>
        candidate !== integrationId &&
        (definition.conflicts.includes(candidate) ||
          getIntegrationDefinition(candidate).conflicts.includes(integrationId))
    )
    if (conflict) {
      throw new Error(
        `Integration "${integrationId}" conflicts with "${conflict}". Remove one provider before continuing.`
      )
    }
  }
}
